import { useEffect, useId, useRef } from 'react';

import CloseIcon from '../../icons/close';

import './styles/sheet.css';

// Native <dialog> gives a real modal: focus is trapped, the page behind is
// inert and Escape closes it. On phones it docks to the bottom as a sheet.
export default function Sheet({ isOpen, title, description, onClose, children, footer }) {
    const dialogRef = useRef(null);
    const titleId = useId();
    const descriptionId = useId();

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;
        if (isOpen && !dialog.open) dialog.showModal();
        if (!isOpen && dialog.open) dialog.close();
    }, [isOpen]);

    const handleCancel = (event) => {
        event.preventDefault();
        onClose();
    };

    const handleBackdropClick = (event) => {
        if (event.target === dialogRef.current) onClose();
    };

    return (
        <dialog
            ref={dialogRef}
            className="sheet"
            aria-labelledby={titleId}
            aria-describedby={description ? descriptionId : undefined}
            onCancel={handleCancel}
            onClick={handleBackdropClick}
        >
            {isOpen && (
                <div className="sheet__panel">
                    <header className="sheet__header">
                        <h2 id={titleId} className="sheet__title">{title}</h2>
                        <button type="button" className="sheet__close" onClick={onClose}>
                            <CloseIcon />
                            <span className="visually-hidden">Cerrar</span>
                        </button>
                    </header>
                    {description && <p id={descriptionId} className="sheet__description">{description}</p>}
                    <div className="sheet__body">{children}</div>
                    {footer && <footer className="sheet__footer">{footer}</footer>}
                </div>
            )}
        </dialog>
    );
}
